/** 将 MB 格式化为可读大小标签 */
export function formatFileSizeMb(mb) {
  if (mb == null || Number.isNaN(mb)) return '—';
  if (mb >= 1024) {
    const gb = mb / 1024;
    return `${Number.isInteger(gb) ? gb : gb.toFixed(1)}GB`;
  }
  return `${mb}MB`;
}
